import React from 'react';
import {
    Box,
    Typography,
    LinearProgress
} from '@mui/material';

const LoadingScreen = ({ message = "Loading..." }) => {
    return (
        <Box sx={{
            minHeight: '100vh',
            bgcolor: 'background.default',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <Box sx={{ textAlign: 'center' }}>
                <LinearProgress 
                    sx={{ 
                        width: 300, 
                        mb: 2,
                        '& .MuiLinearProgress-bar': {
                            background: 'linear-gradient(135deg, #0a0068 0%, #cc4049 100%)',
                        },
                        '& .MuiLinearProgress-root': {
                            backgroundColor: 'rgba(10, 0, 104, 0.1)',
                        }
                    }} 
                />
                <Typography 
                    variant="body2" 
                    color="text.secondary"
                    sx={{
                        fontSize: '0.9rem',
                        fontWeight: 500
                    }}
                >
                    {message}
                </Typography>
            </Box>
        </Box>
    );
};

export default LoadingScreen;